<div [hidden]="loading" id="payment-element" class="single-column-row">
    <!-- Stripe Elements will create form elements here -->
</div>
<form [hidden]="loading" [formGroup]="form" class="sb-legacy-form">
    @if (Scope.context != PaymentContext.SignupWidget && Scope.mode === PaymentSourceMode.Payment) {
        <lib-checkbox
            [formControl]="form.controls.SavePaymentSource"
            (change)="SavePaymentMethodForFuture($event)"
            [qaTag]="'save-payment-method-for-future-use-checkbox'">
            <ng-container
                i18n="@@CommonAddPaymentSourceSavePaymentSourceLabel">
                Save this payment method for future use
            </ng-container>
        </lib-checkbox>
    }

    @if (Scope.context != PaymentContext.SignupWidget && (Scope.mode === PaymentSourceMode.Add || (Scope.mode === PaymentSourceMode.Payment && form.controls.SavePaymentSource.value))) {
        <div class="pb-2" [ngClass]="{'pt-3': Scope.mode === PaymentSourceMode.Payment}">
            <lib-checkbox
                [formControl]="form.controls.AutoPay"
                [qaTag]="'automatically-pay-emailed-invoices-checkbox'">
                <ng-container label
                    i18n="@@CommonAddPaymentSourceAutoPayLabel">
                    Auto Pay
                </ng-container>
                <ng-container i18n="@@CommonAddPaymentSourceAutoPayCheckboxDescription">
                    Automatically pay emailed invoices
                </ng-container>
            </lib-checkbox>
        </div>
    }

    @if ((Scope.context === PaymentContext.StudentPortal && Scope.mode === PaymentSourceMode.Add) || (Scope.context === PaymentContext.SignupWidget && Scope.mode === PaymentSourceMode.Payment)) {
        @if (cardSurcharge && cardSurcharge.Type !== SurchargeType.None && paymentSourceType === PaymentSourceType.CreditCard) {
            <div class="py-2" [attr.data-sb-qa]="'surcharge-text-creditcard'">
                <lib-label i18n="@@CommonNoteLabel">Note</lib-label>
                <ul>
                    @if (cardSurcharge.Type === SurchargeType.Fixed) {
                        <li>
                            <p data-clarity-mask="true" i18n="@@CommonCreditCardFixedSurchargeText">
                                A {{ cardSurcharge.Amount! | formatCurrency }} convenience fee will be applied to all credit card payments.
                            </p>
                        </li>
                    }
                    @if (cardSurcharge.Type === SurchargeType.Percentage) {
                        <li>
                            <p data-clarity-mask="true" i18n="@@CommonCreditCardPercentageSurchargeText">
                                A {{ cardSurcharge.Amount! | formatPercent: 2: 2 }} convenience fee will be applied to all credit card payments.
                            </p>
                        </li>
                    }
                </ul>
            </div>
        }

        @if (cardSurcharge && cardSurcharge.Type !== SurchargeType.None && paymentSourceType === PaymentSourceType.StripeLink) {
            <div class="py-2" [attr.data-sb-qa]="'surcharge-text-stripelink'">
                <lib-label i18n="@@CommonNoteLabel">Note</lib-label>
                <ul>
                    @if (cardSurcharge.Type === SurchargeType.Fixed) {
                        <li>
                            <p data-clarity-mask="true" i18n="@@CommonStripeLinkFixedSurchargeText">
                                A {{ cardSurcharge.Amount! | formatCurrency }} convenience fee will be applied to all Stripe Link payments.
                            </p>
                        </li>
                    }
                    @if (cardSurcharge.Type === SurchargeType.Percentage) {
                        <li>
                            <p data-clarity-mask="true" i18n="@@CommonStripeLinkPercentageSurchargeText">
                                A {{ cardSurcharge.Amount! | formatPercent: 2: 2 }} convenience fee will be applied to all Stripe Link payments.
                            </p>
                        </li>
                    }
                </ul>
            </div>
        }

        @if (bankSurcharge && bankSurcharge.Type !== SurchargeType.None && (paymentSourceType === PaymentSourceType.BankAccount || paymentSourceType === PaymentSourceType.iDEAL)) {
            <div class="py-2" [attr.data-sb-qa]="'surcharge-text-bank'">
                <lib-label i18n="@@CommonNoteLabel">Note</lib-label>
                <ul>
                    @if (bankSurcharge.Type === SurchargeType.Fixed) {
                        <li>
                            <p data-clarity-mask="true" i18n="@@CommonBankFixedSurchargeText">
                                A {{ bankSurcharge.Amount! | formatCurrency }} convenience fee will be applied to all bank payments.
                            </p>
                        </li>
                    }
                    @if (bankSurcharge.Type === SurchargeType.Percentage) {
                        <li>
                            <p data-clarity-mask="true" i18n="@@CommonBankPercentageSurchargeText">
                                A {{ bankSurcharge.Amount! | formatPercent: 2: 2 }} convenience fee will be applied to all bank payments.
                            </p>
                        </li>
                    }
                    @if ((Scope.context === PaymentContext.StudentPortal && Scope.mode === PaymentSourceMode.Add && paymentSourceType === PaymentSourceType.iDEAL)) {
                        <li>
                            <p i18n="@@CommonStudentsPaymentSourcesiDealSepaChargeAndRefundNotice">
                                To set up your bank account via iDEAL, we'll charge a small amount (around {{minimumPaymentWithFudgeFactor | formatCurrency}}). This amount will be automatically refunded.
                            </p>
                        </li>
                    }
                </ul>
            </div>
        }
    }
</form>

<div [hidden]="!loading">
    <div class="h-100 d-flex align-items-center justify-content-center">
        <div class="spinner-border base-100 m-5"></div>
    </div>
</div>